/**
 * Created by asiulik on 03.04.2018.
 */

(function () {

    function Shaker() {
    }

    Shaker.prototype.init = function () {

        var _this = this;

        var requiredCount = 20;

        this.shakeInstance = new Shake({threshold: 1.5});
        this.shakeInstance.start();

        var startButton = document.querySelector('#startButton');
        var box = document.querySelector('#backgroundBoxFirst .box__background');
        var box2 = document.querySelector('#backgroundBoxSecond .box__background');
        var shakeCountElem = document.querySelector('#shakeCountElem');

        var startBox = document.querySelector('#startBox');
        var actionBox = document.querySelector('#actionBox');

        var shakeCount = 0;

        var started = false;

        if (!shakeCountElem) return;

        started = true;

        this.shakeAction = function(){

            shakeAction();
        };

        window.addEventListener('shakeY', _this.shakeAction, false);

        var shakreInterval = setInterval(() => {
            // shakeAction();
        }, 1000);

        function shakeAction() {

            if (!started) return;

            shakeCount++;

            if(shakeCount > requiredCount) return;

            if(shakeCount == 1) {
                document.querySelector('#afterFirstActionCorrect').style.display = 'block';
            }

            if (shakeCount == requiredCount) {

                if (shakreInterval) clearInterval(shakreInterval);
                var text = document.querySelector('.text-info');
                text.innerHTML = "Herzliche Gratulation!<br> Du hast es geschafft. ";
                var button = document.querySelector('#nextButton');
                button.removeAttribute('disabled');

            }

            var halfCompleted = isHalfCompleted(requiredCount, shakeCount);

            var countValue = shakeCount < 10 ? '0' + shakeCount : shakeCount;
            var countToP = halfCompleted ? shakeCount - (requiredCount / 2) : shakeCount;
            shakeCountElem.innerHTML = countValue;

            var boxToUpdate = halfCompleted ? box2 : box;

            boxToUpdate.style.height = (countToP * 10) + '%';

        }

    };


    Shaker.prototype.destroy = function(){

        if(this.shakeAction){
            window.removeEventListener('shakeY', this.shakeAction);
        }

        if(this.shakeInstance){
            this.shakeInstance.stop();
        }

    };

    function isHalfCompleted(totalCount, currentCount) {
        return totalCount / currentCount < 2
    }

    window.Shaker = Shaker;

})();